import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import s from './CCButton.scss';
import Icon from './icon.svg';
export const CCButton = ({ big, enabled, onClick, }) => {
    const ref = useRef(null);
    const iconSize = big ? 28 : 22;
    useEffect(() => {
        const button = ref.current;
        if (!button) {
            return;
        }
        // React onClick doesn't work because of:
        // https://github.com/wix/playable/blob/9bf6b3a793cab50a1e2ab166cf4bb550fb757957/src/modules/ui/bottom-block/bottom-block.view.ts#L99
        // So add click handler in such weird way
        button.addEventListener('click', onClick);
        return () => {
            button.removeEventListener('click', onClick);
        };
    }, [onClick]);
    return (React.createElement("button", { ref: ref, className: classNames(s.button, { [s.disabled]: !enabled }), "data-hook": "wix-vod-playable-cc-button" },
        React.createElement(Icon, { height: iconSize, width: iconSize })));
};
export function createCCButtonContainer() {
    const element = document.createElement('div');
    element.className = s.root;
    element.setAttribute('data-hook', 'wix-vod-playable-cc-button-container');
    return {
        element,
    };
}
//# sourceMappingURL=CCButton.js.map